/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as AppAppVersionLogRouteImport } from './routes/_app/app-version-log'
import { Route as AppClientTypesRouteImport } from './routes/_app/client-types'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppRelationshipManagersRouteImport } from './routes/_app/relationship-managers'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppTasksRouteImport } from './routes/_app/tasks'
import { Route as DevComponentsRouteImport } from './routes/dev.components'
import { Route as AppAppContentAnnouncementsRouteImport } from './routes/_app/app-content/announcements'
import { Route as AppAppContentLookbookRouteImport } from './routes/_app/app-content/lookbook'
import { Route as AppAppContentMessagesRouteImport } from './routes/_app/app-content/messages'
import { Route as AppAppContentVideosRouteImport } from './routes/_app/app-content/videos'
import { Route as AppCustomersIndexRouteImport } from './routes/_app/customers.index'
import { Route as AppCustomersCustomerIdRouteImport } from './routes/_app/customers.$customerId'
import { Route as AppLookbooksIndexRouteImport } from './routes/_app/lookbooks/index'
import { Route as AppLookbooksLookbookIdRouteImport } from './routes/_app/lookbooks/$lookbookId'
import { Route as AppLookbooksNewRouteImport } from './routes/_app/lookbooks/new'
import { Route as AppOrdersIndexRouteImport } from './routes/_app/orders/index'
import { Route as AppOrdersOrderIdRouteImport } from './routes/_app/orders/$orderId'
import { Route as AppOrdersNewRouteImport } from './routes/_app/orders/new'
import { Route as AppProductsIndexRouteImport } from './routes/_app/products/index'
import { Route as AppProductsProductIdRouteImport } from './routes/_app/products/$productId'
import { Route as AppProductsNewRouteImport } from './routes/_app/products/new'
import { Route as AppProductsSettingsRouteImport } from './routes/_app/products/settings'
import { Route as AppSuppliersIndexRouteImport } from './routes/_app/suppliers.index'
import { Route as AppSuppliersSupplierIdRouteImport } from './routes/_app/suppliers.$supplierId'
import { Route as AppSuppliersNewRouteImport } from './routes/_app/suppliers.new'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAppVersionLogRoute = AppAppVersionLogRouteImport.update({
  id: '/app-version-log',
  path: '/app-version-log',
  getParentRoute: () => AppRoute,
} as any)
const AppClientTypesRoute = AppClientTypesRouteImport.update({
  id: '/client-types',
  path: '/client-types',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppRelationshipManagersRoute = AppRelationshipManagersRouteImport.update({
  id: '/relationship-managers',
  path: '/relationship-managers',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const DevComponentsRoute = DevComponentsRouteImport.update({
  id: '/dev/components',
  path: '/dev/components',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAppContentAnnouncementsRoute =
  AppAppContentAnnouncementsRouteImport.update({
    id: '/app-content/announcements',
    path: '/app-content/announcements',
    getParentRoute: () => AppRoute,
  } as any)
const AppAppContentLookbookRoute = AppAppContentLookbookRouteImport.update({
  id: '/app-content/lookbook',
  path: '/app-content/lookbook',
  getParentRoute: () => AppRoute,
} as any)
const AppAppContentMessagesRoute = AppAppContentMessagesRouteImport.update({
  id: '/app-content/messages',
  path: '/app-content/messages',
  getParentRoute: () => AppRoute,
} as any)
const AppAppContentVideosRoute = AppAppContentVideosRouteImport.update({
  id: '/app-content/videos',
  path: '/app-content/videos',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersCustomerIdRoute = AppCustomersCustomerIdRouteImport.update({
  id: '/customers/$customerId',
  path: '/customers/$customerId',
  getParentRoute: () => AppRoute,
} as any)
const AppLookbooksIndexRoute = AppLookbooksIndexRouteImport.update({
  id: '/lookbooks/',
  path: '/lookbooks/',
  getParentRoute: () => AppRoute,
} as any)
const AppLookbooksLookbookIdRoute = AppLookbooksLookbookIdRouteImport.update({
  id: '/lookbooks/$lookbookId',
  path: '/lookbooks/$lookbookId',
  getParentRoute: () => AppRoute,
} as any)
const AppLookbooksNewRoute = AppLookbooksNewRouteImport.update({
  id: '/lookbooks/new',
  path: '/lookbooks/new',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersIndexRoute = AppOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersOrderIdRoute = AppOrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersNewRoute = AppOrdersNewRouteImport.update({
  id: '/orders/new',
  path: '/orders/new',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsIndexRoute = AppProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsProductIdRoute = AppProductsProductIdRouteImport.update({
  id: '/products/$productId',
  path: '/products/$productId',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsNewRoute = AppProductsNewRouteImport.update({
  id: '/products/new',
  path: '/products/new',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsSettingsRoute = AppProductsSettingsRouteImport.update({
  id: '/products/settings',
  path: '/products/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSuppliersIndexRoute = AppSuppliersIndexRouteImport.update({
  id: '/suppliers/',
  path: '/suppliers/',
  getParentRoute: () => AppRoute,
} as any)
const AppSuppliersSupplierIdRoute = AppSuppliersSupplierIdRouteImport.update({
  id: '/suppliers/$supplierId',
  path: '/suppliers/$supplierId',
  getParentRoute: () => AppRoute,
} as any)
const AppSuppliersNewRoute = AppSuppliersNewRouteImport.update({
  id: '/suppliers/new',
  path: '/suppliers/new',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/set-password': typeof SetPasswordRoute
  '/app-version-log': typeof AppAppVersionLogRoute
  '/client-types': typeof AppClientTypesRoute
  '/dashboard': typeof AppDashboardRoute
  '/notifications': typeof AppNotificationsRoute
  '/relationship-managers': typeof AppRelationshipManagersRoute
  '/reports': typeof AppReportsRoute
  '/tasks': typeof AppTasksRoute
  '/dev/components': typeof DevComponentsRoute
  '/app-content/announcements': typeof AppAppContentAnnouncementsRoute
  '/app-content/lookbook': typeof AppAppContentLookbookRoute
  '/app-content/messages': typeof AppAppContentMessagesRoute
  '/app-content/videos': typeof AppAppContentVideosRoute
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/lookbooks/$lookbookId': typeof AppLookbooksLookbookIdRoute
  '/lookbooks/new': typeof AppLookbooksNewRoute
  '/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/orders/new': typeof AppOrdersNewRoute
  '/products/$productId': typeof AppProductsProductIdRoute
  '/products/new': typeof AppProductsNewRoute
  '/products/settings': typeof AppProductsSettingsRoute
  '/suppliers/$supplierId': typeof AppSuppliersSupplierIdRoute
  '/suppliers/new': typeof AppSuppliersNewRoute
  '/customers/': typeof AppCustomersIndexRoute
  '/lookbooks/': typeof AppLookbooksIndexRoute
  '/orders/': typeof AppOrdersIndexRoute
  '/products/': typeof AppProductsIndexRoute
  '/suppliers/': typeof AppSuppliersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/set-password': typeof SetPasswordRoute
  '/app-version-log': typeof AppAppVersionLogRoute
  '/client-types': typeof AppClientTypesRoute
  '/dashboard': typeof AppDashboardRoute
  '/notifications': typeof AppNotificationsRoute
  '/relationship-managers': typeof AppRelationshipManagersRoute
  '/reports': typeof AppReportsRoute
  '/tasks': typeof AppTasksRoute
  '/dev/components': typeof DevComponentsRoute
  '/app-content/announcements': typeof AppAppContentAnnouncementsRoute
  '/app-content/lookbook': typeof AppAppContentLookbookRoute
  '/app-content/messages': typeof AppAppContentMessagesRoute
  '/app-content/videos': typeof AppAppContentVideosRoute
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/lookbooks/$lookbookId': typeof AppLookbooksLookbookIdRoute
  '/lookbooks/new': typeof AppLookbooksNewRoute
  '/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/orders/new': typeof AppOrdersNewRoute
  '/products/$productId': typeof AppProductsProductIdRoute
  '/products/new': typeof AppProductsNewRoute
  '/products/settings': typeof AppProductsSettingsRoute
  '/suppliers/$supplierId': typeof AppSuppliersSupplierIdRoute
  '/suppliers/new': typeof AppSuppliersNewRoute
  '/customers': typeof AppCustomersIndexRoute
  '/lookbooks': typeof AppLookbooksIndexRoute
  '/orders': typeof AppOrdersIndexRoute
  '/products': typeof AppProductsIndexRoute
  '/suppliers': typeof AppSuppliersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/set-password': typeof SetPasswordRoute
  '/_app/app-version-log': typeof AppAppVersionLogRoute
  '/_app/client-types': typeof AppClientTypesRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/relationship-managers': typeof AppRelationshipManagersRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/tasks': typeof AppTasksRoute
  '/dev/components': typeof DevComponentsRoute
  '/_app/app-content/announcements': typeof AppAppContentAnnouncementsRoute
  '/_app/app-content/lookbook': typeof AppAppContentLookbookRoute
  '/_app/app-content/messages': typeof AppAppContentMessagesRoute
  '/_app/app-content/videos': typeof AppAppContentVideosRoute
  '/_app/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/_app/lookbooks/$lookbookId': typeof AppLookbooksLookbookIdRoute
  '/_app/lookbooks/new': typeof AppLookbooksNewRoute
  '/_app/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/_app/orders/new': typeof AppOrdersNewRoute
  '/_app/products/$productId': typeof AppProductsProductIdRoute
  '/_app/products/new': typeof AppProductsNewRoute
  '/_app/products/settings': typeof AppProductsSettingsRoute
  '/_app/suppliers/$supplierId': typeof AppSuppliersSupplierIdRoute
  '/_app/suppliers/new': typeof AppSuppliersNewRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/lookbooks/': typeof AppLookbooksIndexRoute
  '/_app/orders/': typeof AppOrdersIndexRoute
  '/_app/products/': typeof AppProductsIndexRoute
  '/_app/suppliers/': typeof AppSuppliersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/set-password'
    | '/app-version-log'
    | '/client-types'
    | '/dashboard'
    | '/notifications'
    | '/relationship-managers'
    | '/reports'
    | '/tasks'
    | '/dev/components'
    | '/app-content/announcements'
    | '/app-content/lookbook'
    | '/app-content/messages'
    | '/app-content/videos'
    | '/customers/$customerId'
    | '/lookbooks/$lookbookId'
    | '/lookbooks/new'
    | '/orders/$orderId'
    | '/orders/new'
    | '/products/$productId'
    | '/products/new'
    | '/products/settings'
    | '/suppliers/$supplierId'
    | '/suppliers/new'
    | '/customers/'
    | '/lookbooks/'
    | '/orders/'
    | '/products/'
    | '/suppliers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/set-password'
    | '/app-version-log'
    | '/client-types'
    | '/dashboard'
    | '/notifications'
    | '/relationship-managers'
    | '/reports'
    | '/tasks'
    | '/dev/components'
    | '/app-content/announcements'
    | '/app-content/lookbook'
    | '/app-content/messages'
    | '/app-content/videos'
    | '/customers/$customerId'
    | '/lookbooks/$lookbookId'
    | '/lookbooks/new'
    | '/orders/$orderId'
    | '/orders/new'
    | '/products/$productId'
    | '/products/new'
    | '/products/settings'
    | '/suppliers/$supplierId'
    | '/suppliers/new'
    | '/customers'
    | '/lookbooks'
    | '/orders'
    | '/products'
    | '/suppliers'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/forgot-password'
    | '/login'
    | '/set-password'
    | '/_app/app-version-log'
    | '/_app/client-types'
    | '/_app/dashboard'
    | '/_app/notifications'
    | '/_app/relationship-managers'
    | '/_app/reports'
    | '/_app/tasks'
    | '/dev/components'
    | '/_app/app-content/announcements'
    | '/_app/app-content/lookbook'
    | '/_app/app-content/messages'
    | '/_app/app-content/videos'
    | '/_app/customers/$customerId'
    | '/_app/lookbooks/$lookbookId'
    | '/_app/lookbooks/new'
    | '/_app/orders/$orderId'
    | '/_app/orders/new'
    | '/_app/products/$productId'
    | '/_app/products/new'
    | '/_app/products/settings'
    | '/_app/suppliers/$supplierId'
    | '/_app/suppliers/new'
    | '/_app/customers/'
    | '/_app/lookbooks/'
    | '/_app/orders/'
    | '/_app/products/'
    | '/_app/suppliers/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  SetPasswordRoute: typeof SetPasswordRoute
  DevComponentsRoute: typeof DevComponentsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/app-version-log': {
      id: '/_app/app-version-log'
      path: '/app-version-log'
      fullPath: '/app-version-log'
      preLoaderRoute: typeof AppAppVersionLogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/client-types': {
      id: '/_app/client-types'
      path: '/client-types'
      fullPath: '/client-types'
      preLoaderRoute: typeof AppClientTypesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/relationship-managers': {
      id: '/_app/relationship-managers'
      path: '/relationship-managers'
      fullPath: '/relationship-managers'
      preLoaderRoute: typeof AppRelationshipManagersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/dev/components': {
      id: '/dev/components'
      path: '/dev/components'
      fullPath: '/dev/components'
      preLoaderRoute: typeof DevComponentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/app-content/announcements': {
      id: '/_app/app-content/announcements'
      path: '/app-content/announcements'
      fullPath: '/app-content/announcements'
      preLoaderRoute: typeof AppAppContentAnnouncementsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app-content/lookbook': {
      id: '/_app/app-content/lookbook'
      path: '/app-content/lookbook'
      fullPath: '/app-content/lookbook'
      preLoaderRoute: typeof AppAppContentLookbookRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app-content/messages': {
      id: '/_app/app-content/messages'
      path: '/app-content/messages'
      fullPath: '/app-content/messages'
      preLoaderRoute: typeof AppAppContentMessagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app-content/videos': {
      id: '/_app/app-content/videos'
      path: '/app-content/videos'
      fullPath: '/app-content/videos'
      preLoaderRoute: typeof AppAppContentVideosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/$customerId': {
      id: '/_app/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AppCustomersCustomerIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lookbooks/': {
      id: '/_app/lookbooks/'
      path: '/lookbooks'
      fullPath: '/lookbooks/'
      preLoaderRoute: typeof AppLookbooksIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lookbooks/$lookbookId': {
      id: '/_app/lookbooks/$lookbookId'
      path: '/lookbooks/$lookbookId'
      fullPath: '/lookbooks/$lookbookId'
      preLoaderRoute: typeof AppLookbooksLookbookIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lookbooks/new': {
      id: '/_app/lookbooks/new'
      path: '/lookbooks/new'
      fullPath: '/lookbooks/new'
      preLoaderRoute: typeof AppLookbooksNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/': {
      id: '/_app/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AppOrdersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/$orderId': {
      id: '/_app/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AppOrdersOrderIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/new': {
      id: '/_app/orders/new'
      path: '/orders/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof AppOrdersNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products/': {
      id: '/_app/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AppProductsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products/$productId': {
      id: '/_app/products/$productId'
      path: '/products/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof AppProductsProductIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products/new': {
      id: '/_app/products/new'
      path: '/products/new'
      fullPath: '/products/new'
      preLoaderRoute: typeof AppProductsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products/settings': {
      id: '/_app/products/settings'
      path: '/products/settings'
      fullPath: '/products/settings'
      preLoaderRoute: typeof AppProductsSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/suppliers/': {
      id: '/_app/suppliers/'
      path: '/suppliers'
      fullPath: '/suppliers/'
      preLoaderRoute: typeof AppSuppliersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/suppliers/$supplierId': {
      id: '/_app/suppliers/$supplierId'
      path: '/suppliers/$supplierId'
      fullPath: '/suppliers/$supplierId'
      preLoaderRoute: typeof AppSuppliersSupplierIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/suppliers/new': {
      id: '/_app/suppliers/new'
      path: '/suppliers/new'
      fullPath: '/suppliers/new'
      preLoaderRoute: typeof AppSuppliersNewRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAppVersionLogRoute: typeof AppAppVersionLogRoute
  AppClientTypesRoute: typeof AppClientTypesRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppRelationshipManagersRoute: typeof AppRelationshipManagersRoute
  AppReportsRoute: typeof AppReportsRoute
  AppTasksRoute: typeof AppTasksRoute
  AppAppContentAnnouncementsRoute: typeof AppAppContentAnnouncementsRoute
  AppAppContentLookbookRoute: typeof AppAppContentLookbookRoute
  AppAppContentMessagesRoute: typeof AppAppContentMessagesRoute
  AppAppContentVideosRoute: typeof AppAppContentVideosRoute
  AppCustomersCustomerIdRoute: typeof AppCustomersCustomerIdRoute
  AppLookbooksLookbookIdRoute: typeof AppLookbooksLookbookIdRoute
  AppLookbooksNewRoute: typeof AppLookbooksNewRoute
  AppOrdersOrderIdRoute: typeof AppOrdersOrderIdRoute
  AppOrdersNewRoute: typeof AppOrdersNewRoute
  AppProductsProductIdRoute: typeof AppProductsProductIdRoute
  AppProductsNewRoute: typeof AppProductsNewRoute
  AppProductsSettingsRoute: typeof AppProductsSettingsRoute
  AppSuppliersSupplierIdRoute: typeof AppSuppliersSupplierIdRoute
  AppSuppliersNewRoute: typeof AppSuppliersNewRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
  AppLookbooksIndexRoute: typeof AppLookbooksIndexRoute
  AppOrdersIndexRoute: typeof AppOrdersIndexRoute
  AppProductsIndexRoute: typeof AppProductsIndexRoute
  AppSuppliersIndexRoute: typeof AppSuppliersIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAppVersionLogRoute: AppAppVersionLogRoute,
  AppClientTypesRoute: AppClientTypesRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppRelationshipManagersRoute: AppRelationshipManagersRoute,
  AppReportsRoute: AppReportsRoute,
  AppTasksRoute: AppTasksRoute,
  AppAppContentAnnouncementsRoute: AppAppContentAnnouncementsRoute,
  AppAppContentLookbookRoute: AppAppContentLookbookRoute,
  AppAppContentMessagesRoute: AppAppContentMessagesRoute,
  AppAppContentVideosRoute: AppAppContentVideosRoute,
  AppCustomersCustomerIdRoute: AppCustomersCustomerIdRoute,
  AppLookbooksLookbookIdRoute: AppLookbooksLookbookIdRoute,
  AppLookbooksNewRoute: AppLookbooksNewRoute,
  AppOrdersOrderIdRoute: AppOrdersOrderIdRoute,
  AppOrdersNewRoute: AppOrdersNewRoute,
  AppProductsProductIdRoute: AppProductsProductIdRoute,
  AppProductsNewRoute: AppProductsNewRoute,
  AppProductsSettingsRoute: AppProductsSettingsRoute,
  AppSuppliersSupplierIdRoute: AppSuppliersSupplierIdRoute,
  AppSuppliersNewRoute: AppSuppliersNewRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
  AppLookbooksIndexRoute: AppLookbooksIndexRoute,
  AppOrdersIndexRoute: AppOrdersIndexRoute,
  AppProductsIndexRoute: AppProductsIndexRoute,
  AppSuppliersIndexRoute: AppSuppliersIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  SetPasswordRoute: SetPasswordRoute,
  DevComponentsRoute: DevComponentsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
